module.exports = __webpack_public_path__ + "img/nxmj.a54050b2.jpg";